import classnames from "classnames";
import { MdErrorOutline, MdOutlineErrorOutline } from "react-icons/md";
import { Input } from "antd";
import { ErrorMessage } from "formik";
import { useFormikContext } from "formik";

/* eslint-disable react/prop-types */
const TextInput = ({
  type = "text",
  title,
  name,
  placeholder,
  requiredField = false,
  errors = {},
  touched = {},
  values = {},
  handleChange = () => {},
  handleBlur = () => {},
  disabled = false,
  readOnly = false,
  extraDetails = "",
  icon,
}) => {
  const hasError = errors?.[name] && touched?.[name];
  const value = values?.[name] ?? "";

  let formikContext;

  try {
    formikContext = useFormikContext();
  } catch (err) {
    formikContext = null;
  }

  return (
    <div className="mb-4">
      <label
        htmlFor={name}
        className="block leading-6 text-gray-500 mb-2 text-sm"
      >
        {title}
        {requiredField && <span className="text-red-800 mx-1">*</span>}
      </label>

      {extraDetails && (
        <p className="leading-6 text-gray-500 text-xs my-1">{extraDetails}</p>
      )}

      <div>
        <Input
          size="small"
          id={name}
          name={name}
          readOnly={readOnly}
          disabled={disabled}
          type={type}
          prefix={icon && icon}
          placeholder={placeholder}
          onChange={handleChange(name)}
          autoComplete="off"
          onBlur={handleBlur(name)}
          value={value}
          className={classnames(
            "h-[36px] block w-full border-0 py-[6px] text-gray-500 ring-1 ring-inset placeholder:text-gray-400 placeholder:font-light focus:ring-inset text-sm sm:leading-6",
            hasError
              ? "ring-red-600 focus:ring-red-600 text-red-600"
              : "ring-gray-300/10 focus:ring-primary-dark",
            readOnly &&
              "bg-gray-100 hover:bg-gray-100 focus:bg-gray-100 cursor-not-allowed"
          )}
        />
      </div>
      {formikContext && name && (
        <ErrorMessage name={name}>
          {(msg) => (
            <div className="text-xs text-red-500 text-left w-full flex gap-1 items-center mt-1">
              <MdOutlineErrorOutline size={16} />
              <p className="text-xs">{msg}</p>
            </div>
          )}
        </ErrorMessage>
      )}
      {/* 
      {hasError && (
        <div className="text-xs text-red-500 text-left w-full flex gap-1 items-center mt-1">
          <MdOutlineErrorOutline size={16} />
          <p className="text-xs">{errors[name]}</p>
        </div>
      )} */}
    </div>
  );
};

export default TextInput;
